import React from 'react';
import { Box, InputLabel, Typography, FormControl } from '@mui/material';

const brandIcons = {
  visa: '💳 VISA',
  mastercard: '💳 MASTERCARD',
  amex: '💳 AMEX',
  discover: '💳 DISCOVER',
  diners: '💳 DINERS',
  jcb: '💳 JCB',
  unionpay: '💳 UNIONPAY',
  unknown: '💳 CARD',
};

function SavedCardDetails({ card }) {
  if (!card) {
    return <Typography>No saved card found.</Typography>;
  }

  const { brand, last4, exp_month, exp_year } = card.card;
  const iconLabel = brandIcons[brand] || brandIcons.unknown;

  const renderField = ({ label, value, id, showLabel = false }) => (
    <FormControl fullWidth variant="outlined" margin="normal">
      {showLabel && (
        <InputLabel shrink htmlFor={id}>
          {label}
        </InputLabel>
      )}
      <Box
        id={id}
        sx={{
          mt: showLabel ? 1 : 0,
          border: '1px solid',
          borderColor: 'rgba(0, 0, 0, 0.23)',
          borderRadius: 1,
          padding: '0 14px',
          fontSize: '16px',
          color: '#000',
          backgroundColor: '#fafafa',
          textAlign: 'left',
          lineHeight: '1.4375em',
          display: 'flex',
          alignItems: 'center',
          height: '56px',
        }}
      >
        {value}
      </Box>
    </FormControl>
  );

  return (
    <Box>
      {renderField({
        label: 'Card Number',
        value: (
          <>
            <Box sx={{ mr: 1 }}>{iconLabel}</Box>
            **** **** **** {last4}
          </>
        ),
        id: 'card-number',
        showLabel: true,
      })}
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ flex: 1 }}>
          {renderField({
            value: `${exp_month}/${exp_year}`,
            id: 'card-expiry',
          })}
        </Box>
        <Box sx={{ flex: 1 }}>
          {renderField({
            value: '***',
            id: 'card-cvc',
          })}
        </Box>
      </Box>
    </Box>
  );
}

export default SavedCardDetails;
